module.exports = __webpack_public_path__ + "img/MejoraCareLogotype.ff007d41.svg";